import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import { styled } from '@mui/material/styles'
import React from 'react'

import Tooltip from '@/app/component/atom/tooltip'
import FloatingSaveBar from '@/app/component/layout/floating-save-bar'

import { exitButtonOptions, FlexContainer } from './common'

export type Props = {
  isQuestionType: boolean
  selectedAnswer: string
  exitButtonOpen: boolean
  exitButtonGroupRef: React.RefObject<any>
  onToggle: () => void
  onClose: (event: any) => void
  onMenuItemClick: (status: 'save' | 'exit') => void
  onCompleteStep: () => void
}

const CATIControls: React.FC<Props> = ({
  isQuestionType,
  selectedAnswer,
  exitButtonOpen,
  exitButtonGroupRef,
  onToggle,
  onClose,
  onMenuItemClick,
  onCompleteStep,
}) => (
  <FloatingSaveBar>
    <ButtonGroup variant="contained" color="primary" ref={exitButtonGroupRef} aria-label="exit button">
      <Button id="cati-exit-survey-dropdown-btn" onClick={onToggle}>
        Exit Survey
      </Button>
      <Button
        color="primary"
        size="small"
        aria-controls={exitButtonOpen ? 'exit-button-menu' : undefined}
        aria-expanded={exitButtonOpen ? 'true' : undefined}
        aria-label="exit button behavior"
        aria-haspopup="menu"
        onClick={onToggle}
      >
        <ArrowDropDownIcon />
      </Button>
    </ButtonGroup>
    <Popper
      style={{ zIndex: 1300 }}
      open={exitButtonOpen}
      anchorEl={exitButtonGroupRef.current}
      role={undefined}
      transition
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={onClose}>
              <MenuList id="split-button-menu">
                {exitButtonOptions.map((option) => (
                  <Tooltip key={option.id} title={option.tooltip}>
                    <MenuItem id={option.id} onClick={() => onMenuItemClick(option.status)}>
                      {option.label}
                    </MenuItem>
                  </Tooltip>
                ))}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
    <CompleteStepContainer>
      <Button
        id="cati-item-next"
        variant="contained"
        color="primary"
        style={{ marginRight: '0.5rem' }}
        disabled={isQuestionType && !selectedAnswer}
        onClick={onCompleteStep}
      >
        Complete step
      </Button>
    </CompleteStepContainer>
  </FloatingSaveBar>
)

const CompleteStepContainer = styled(FlexContainer)({
  flex: 1,
  justifyContent: 'flex-end',
})

export default CATIControls
